var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 60,
    viewBox: "0 0 115 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3645_55617",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 115,
    height: 60
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 60,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3645_55617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3522 44.5311C32.5973 48.8719 30.0771 53.575 30.0771 53.575L31.3117 54.294C31.3117 54.294 34.1586 49.7811 37.5596 46.9814C41.3829 43.8366 44.443 43.2363 46.6891 39.3526C48.5608 36.1387 45.4904 33.1086 45.5332 31.5686C45.576 30.0287 48.3164 26.7896 48.3164 26.7896L45.5944 25.2043C45.5944 25.2043 44.1294 29.1863 42.8112 29.9834C41.4929 30.7805 37.3462 29.6075 35.4706 32.8192C33.2173 36.6883 34.2027 39.6549 33.3522 44.5311ZM41.0472 33.911C41.1974 33.6531 41.4438 33.4655 41.7323 33.3894C42.0208 33.3132 42.3277 33.3548 42.5855 33.505C42.8434 33.6551 43.031 33.9016 43.1071 34.19C43.1832 34.4785 43.1417 34.7854 42.9915 35.0433L39.2889 41.4011C39.1387 41.6589 38.8923 41.8466 38.6038 41.9227C38.3153 41.9988 38.0084 41.9573 37.7506 41.8071C37.4927 41.6569 37.3051 41.4105 37.229 41.122C37.1528 40.8335 37.1944 40.5266 37.3446 40.2688L41.0472 33.911Z",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5884 -30.0014C92.5884 -30.0014 75.8042 -1.1812 65.0926 12.9912C58.4359 21.7971 49.0387 31.124 49.0387 31.124L45.1501 28.8594L82.7619 -35.724L92.5884 -30.0014Z",
    fill: "#66666D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9416 -41.4428C72.9416 -41.4428 56.1575 -12.6226 49.1167 3.68755C44.7426 13.8228 41.2677 26.5987 41.2677 26.5987L45.1562 28.8633L82.7681 -35.7201L72.9416 -41.4428Z",
    fill: "#66666D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M72.6712 -2.82545C74.0839 -4.86678 75.5361 -7.11431 75.4423 -9.59558C75.4245 -10.0746 75.3227 -10.5974 74.9552 -10.9052C74.0793 -11.6366 72.8681 -10.5584 72.2495 -9.6168C66.4426 -0.773168 59.8451 7.5252 52.5381 15.1762C50.804 16.9913 46.7887 20.6805 49.5821 23.1848C52.4665 25.7654 54.9685 20.7315 56.4905 18.8423C62.1392 11.8195 67.5328 4.59691 72.6712 -2.82545Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHard);
export default __webpack_public_path__ + "static/media/hard.1f1d69f060dbeb89737e04552b734e6a.svg";
export { ForwardRef as ReactComponent };